import React, { useState } from "react";
import "./investPref.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useForm } from "react-hook-form";
import AxiosInstance from "../../../AxiosInstance";
import { alertError } from "../../Helper/Alerts";
import Carousels from "../../../components/Slider/index";
import UseIsMobile from "../../../feature/ismobilescreen";
import { InvestCarousel } from "../../../utils/index";

export default function InvestPref() {
  const navigate = useNavigate();
  const { width } = UseIsMobile();
  const [isMobScreen, setMobScreen] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const { state } = useLocation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
  } = useForm({ mode: "onChange" });
  const onSubmit = async (value) => {
    value.immediateInvestmentAmount = parseInt(
      value?.immediateInvestmentAmount
    );
    value.annualInvestmentAmount = parseInt(value?.annualInvestmentAmount);
    value.expectedReturns = parseInt(value?.expectedReturns);
    value.investmentPeriod = parseInt(value?.investmentPeriod);
    value.payout = parseInt(value?.payout);
    if (state?.payload) {
      AxiosInstance()
        .post("/auth/addNewRole", { userRole: "INVESTOR" })
        .then((resp) => {
          localStorage.setItem("token", resp.data.token);
          AxiosInstance()
            .put("/user/investmentPref", value)
            .then(() => {
              window.location.href = "/policycenter";
            })
            .catch((err) => {
              alertError(err.response.data.message);
            });
        })
        .catch((err) => {
          alertError(err.response.data.message);
        });
      return;
    }
    AxiosInstance()
      .put("/user/investmentPref", value)
      .then(() => {
        window.location.href = "/policycenter";
      })
      .catch((err) => {
        alertError(err.response.data.message);
      });
  };

  return (
    <div className="main-wrapper invest-sec">
      <div className="row">
        {!isMobScreen && (
          <div className="col-md-7 d-md-flex d-none  leftDiv-investPref">
            <Carousels
              CarouselList={InvestCarousel}
              ClassProps="slik-slider-signup "
            />
          </div>
        )}
        <div className="rightDivOTP  col-lg-offset-1 col-md-4 ">
          <div className="p-3 w-md-100 tre-register-block text-start">
            <h2>Investment Preferences</h2>

            <div className="w-100">
              <p>Take a moment to fill in the basic information.</p>
              <form
                id="InvestmentPreferenceForm"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className={`form-group w-100`}>
                  <label htmlFor="annualInvestment">Investment Amount</label>
                  <div className="input-group pb-3">
                    <input
                      type="number"
                      className={`form-control${
                        errors.annualInvestmentAmount ? " is-invalid" : ""
                      }`}
                      id="annualInvestmentAmount"
                      placeholder=""
                      {...register("annualInvestmentAmount", {
                        required: "Investment Amount is Required",
                        min: {
                          value: 1,
                          message: "can not be zero or negative",
                        },
                        pattern: {
                          value: /^[0-9]*$/i,
                          message: "should be a non negative number",
                        },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.annualInvestmentAmount?.message}
                    </div>
                  </div>

                  {/* <label htmlFor="returns">Returns</label>
                  <div className="input-group pb-3">
                    <input
                      type="number"
                      className={`form-control${
                        errors.expectedReturns ? " is-invalid" : ""
                      }`}
                      id="expectedReturns"
                      placeholder="Rs 40000"
                      {...register("expectedReturns", {
                        pattern: {
                          value: /^(?=.*[1-9])\d{1,3}(?:\.\d\d?)?$/i,
                          message: "should be a greater than 0",
                        },
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.expectedReturns?.message}
                    </div>
                  </div> */}

                  <label htmlFor="invesmentPeriod">
                    Investment Period (in years)
                  </label>
                  <div className="input-group pb-3">
                    <input
                      type="number"
                      className={`form-control${
                        errors.investmentPeriod ? " is-invalid" : ""
                      }`}
                      id="investmentPeriod"
                      placeholder=""
                      {...register("investmentPeriod", {
                        required: "Investment Period is Required",
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.investmentPeriod?.message}
                    </div>
                  </div>
                </div>
              </form>
              <button
                form="InvestmentPreferenceForm"
                className="investor-button w-100 mb-3 px-3 py-2 "
              >
                Submit
              </button>
              <p className="skip-text mt-4 pt-4">
                Skip for now ?
                <button
                  className="back-button skip"
                  onClick={() => {
                    onSubmit({});
                  }}
                >
                  Go to Policy Center
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
